import type { Selector } from 'reselect';
import { createSelector } from 'reselect';
import type {
  IAccountRepresentative,
  IAccountRepresentativesState,
  IIndexedAccountReps,
} from './types';

export const selectAccountRepresentatives = (state: IAccountRepresentativesState) =>
  state.accountRepresentatives;

const createAppSelector = createSelector.withTypes<IAccountRepresentativesState>();

export const selectIndexedAccountReps: Selector<IAccountRepresentativesState, IIndexedAccountReps> =
  createAppSelector(selectAccountRepresentatives, (accountReps) =>
    accountReps.reduce((indexed: IIndexedAccountReps, accountRep: IAccountRepresentative) => {
      if (accountRep.representativeCode) {
        indexed[accountRep.representativeCode] = accountRep;
      }
      return indexed;
    }, {}),
  );

export const selectAccountRep: Selector<IAccountRepresentativesState, IAccountRepresentative> =
  createAppSelector(
    [
      selectIndexedAccountReps,
      (_: IAccountRepresentativesState, accountRepCode: string) => accountRepCode,
    ],
    (indexedAccountReps: IIndexedAccountReps, accountRepCode) => indexedAccountReps[accountRepCode],
  );
